import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { IconsModule } from "@va/core-library/icons";

import { FormsModule } from "@angular/forms";
import { AntGridCustomComponent } from "./ant-grid-custom.component";
import { DataCellRenderersModule } from "../data-cell-renderers/data-cell-renderers.module";
import { NzSelectModule } from "ng-zorro-antd/select";

@NgModule({
  declarations: [AntGridCustomComponent],
  imports: [
    CommonModule,
    NzTableModule,
    DataCellRenderersModule,
    FormsModule,
    NzSpinModule,
    IconsModule,
    NzSelectModule,
    NzTableModule,
    NzSpinModule,
  ],
  exports: [AntGridCustomComponent],
})
export class AntGridCustomModule {}
